import * as React from "react"

const SvgComponent = (props) => (
    <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1 3.66667L4.33333 7L9.66667 1" stroke="#557CFF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
)

export default SvgComponent;